import {ApiClient, EnvironmentVariable} from '@cquential/api';
import * as Sentry from '@sentry/vue';
import {App} from 'vue';

export default class SentryHandler {
    public static initialize(app: App): void {
        ApiClient.instance.fetchEnvironmentVariable().then((environmentVariables: EnvironmentVariable[]): void => {
            const dsn: string = environmentVariables.find((environmentVariable: EnvironmentVariable): boolean => {
                return environmentVariable.name === 'sentry-dsn';
            })?.value ?? '';
            const tracesSampleRate: number = Number(environmentVariables.find((environmentVariable: EnvironmentVariable): boolean => {
                return environmentVariable.name === 'sentry-traces-sample-rate';
            })?.value ?? 0);

            Sentry.init({
                app,
                dsn: dsn,
                integrations: [
                    Sentry.browserTracingIntegration(),
                    Sentry.vueIntegration({
                        tracingOptions: {
                            trackComponents: true,
                            hooks: ['create', 'mount'],
                        },
                    }),
                ],
                tracesSampleRate: tracesSampleRate,
            });
        }).catch((): void => {
            // Do nothing since Sentry is a non-critical tool, if it errors we already get a console.error
        });
    }
}
